import React, { useEffect, useState } from 'react';

import Button from '../../atoms/button/button';
import EmotionCard from '../emotion-card/emotionCard';
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import './recommenderSection.scss';
import { generateRandomNumber } from '../../../utils/generalUtilities';

interface RecommenderSectionProps {
  title: string;
  subtitle: string;
  cardsInfo: Array<any>;
  skipBtnText: string;
  nextBtnText: string;
  finishText: string;
  selected: number;
  handleSelections: Function;
  nextBtnEnable: boolean;
  nextBtnFunction: Function;
  skipBtnFunction: Function;
  finishFunction: Function;
  finishEnable: boolean;
  gtmName?: string;
  shuffleText?: string;
}

const RecommenderSection = (props: RecommenderSectionProps) => {
  const [cards, setCards] = useState<Array<any>>([]);

  useEffect(() => {
    props.cardsInfo.length > 6 ? shuffleArray([]) : setCards(props.cardsInfo);
  }, [props.cardsInfo[0].tipoTitulo]);

  const shuffleArray = (array: Array<any> = []) => {
    const arrayLength = props.cardsInfo.length;
  
    for (let i = 0; i < arrayLength; i++) {
      
      const randomIndex =  generateRandomNumber(arrayLength);
      
      if (!array.includes(props.cardsInfo[randomIndex])) {
        array.push(props.cardsInfo[randomIndex]);
      }
    }
    if (array.length < 6) shuffleArray(array);
    setCards(array.slice(0, 6));
  }

  const getCardIndex = (element) => {
    return props.cardsInfo.findIndex(card => card.tipoTitulo === element.tipoTitulo)
  }

  return (
    <div className="m-recommender-section">
      <p className="m-recommender-section__title">{props.title}</p>
      <p className="m-recommender-section__subtitle">{props.subtitle}</p>
      {props.gtmName === "Emocion" && props.cardsInfo.length > 6 &&
        <button 
          className="m-recommender-section__shuffle-emotions"
          type="button"
          disabled={false}
          onClick={() => shuffleArray([])}
        >
          {props.shuffleText}
        </button>
      }
      <ul className="m-recommender-section__cards-container">
        {cards.map((element, index) => (
          <li 
            key={index} 
            className={`
              gtmRecomendadorEleccion${props.gtmName}${normalizeTwoWords(element.tituloBanner)}
              m-recommender-section__card-item`}
            onClick={() => props.handleSelections(getCardIndex(element))}
          >
            <EmotionCard 
              imageSrc={element.imagenPrincipal[0].file.url}
              tituloBanner={element.tituloBanner}
              useDarkMode={false}
              useCheckIcon={true}
              selected={props.selected === getCardIndex(element)}
              gtmClass={`gtmRecomendadorEleccion${props.gtmName}${normalizeTwoWords(element.tituloBanner)}`}
            />
          </li>
        ))}
      </ul>
      <div className="m-recommender-section__buttons">
        <Button 
          type="button"
          classname={`gtmRecomendadorClicPasos${props.gtmName}OmitirPaso primary`}
          text={props.skipBtnText}
          onClickAction={() => props.skipBtnFunction()}
          isDisabled={false}
        />
        <Button 
          type="button"
          classname={`gtmRecomendadorClicPasos${props.gtmName}Siguiente secondary`}
          text={props.nextBtnText}
          onClickAction={() => props.nextBtnFunction()}
          isDisabled={!props.nextBtnEnable}
        />
      </div>
      <a 
        className={`m-recommender-section__finish-text 
          ${!props.finishEnable ? "m-recommender-section__finish-text--disabled" : ""}
          gtmRecomendadorClicRecomiendameLeer${props.gtmName}`
        }
        onClick={props.finishEnable ? () => props.finishFunction() : () => true}
      >
        {props.finishText}
      </a>
    </div>
  )
}

export default RecommenderSection;